<template>
  <v-chip
    outlined
    label
    small
    :color="color"
    class="light-background caption px-2 border--none"
    @click="completed ? null : $emit('click')"
  >
    <v-icon size="15" class="mr-2">{{ icon }}</v-icon>
    {{ text }}
  </v-chip>
</template>

<script>
import moment from "moment";
export default {
  name: "DueDateChip",
  props: {
    dueDate: { type: String },
    completed: { type: Boolean, default: false }
  },
  computed: {
    icon() {
      return this.completed ? "done" : "notifications_active";
    },
    text() {
      if (this.completed) {
        return this.$options.filters.longDate(this.dueDate);
      }
      let dueDate = moment(this.dueDate);
      let now = moment(moment().format("YYYY-MM-DD"));
      let diff = dueDate.diff(now, "days");

      if (diff > 30) {
        return `Due ${dueDate.format("MMMM DD, YYYY")}`;
      } else if (diff < 0) {
        return `Overdue ${Math.abs(diff)} days`;
      } else if (diff == 0) {
        return "Today";
      }

      return `Due in ${diff} days`;
    },
    color() {
      if (this.completed) {
        return this.$vuetify.theme.themes.light.lighttext;
      }
      let dueDate = moment(this.dueDate);
      let now = moment(moment().format("YYYY-MM-DD"));
      let diff = dueDate.diff(now, "days");

      if (diff > 30) {
        return this.$vuetify.theme.themes.light.secondary;
      } else if (diff < 0) {
        return this.$vuetify.theme.themes.light.error;
      }

      return this.$vuetify.theme.themes.light.darkaccent;
    }
  }
};
</script>
